import { createSelector } from 'reselect';
import { updatedAccountPerksSelector } from 'selectors/testTarget/offers/updatedAccountPerks/updatedAccountPerksSelector';

const showSelector = createSelector(updatedAccountPerksSelector, updatedAccountPerks => !!updatedAccountPerks.show);

export { showSelector };
